import script from "./HairSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./HairSelection.vue?vue&type=script&setup=true&lang=js"

import "./HairSelection.vue?vue&type=style&index=0&id=7480f6fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hairwizard/hairwizard/hwappointments/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7480f6fc"]])

export default __exports__